import React, { PropsWithChildren } from "react";
import { useReadonlyContext } from "utilities/contexts/readonly/use-readonly-context";

interface HideIfReadonlyProps {}

export const HideIfReadonly: React.FC<
    PropsWithChildren<HideIfReadonlyProps>
> = ({ children }): JSX.Element => {
    const { isReadonly } = useReadonlyContext();

    if (isReadonly) {
        return <></>;
    }

    return <>{children}</>;
};
